webpackJsonp([33781710060979],{

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _page = __webpack_require__(5);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _contentblock = __webpack_require__(9);
	
	var _contentblock2 = _interopRequireDefault(_contentblock);
	
	var _abblock = __webpack_require__(53);
	
	var _abblock2 = _interopRequireDefault(_abblock);
	
	var _sidebar = __webpack_require__(18);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _discovery = __webpack_require__(153);
	
	var _discovery2 = _interopRequireDefault(_discovery);
	
	var _discovery2x = __webpack_require__(154);
	
	var _discovery2x2 = _interopRequireDefault(_discovery2x);
	
	var _logiq = __webpack_require__(155);
	
	var _logiq2 = _interopRequireDefault(_logiq);
	
	var _logiq2x = __webpack_require__(156);
	
	var _logiq2x2 = _interopRequireDefault(_logiq2x);
	
	var _senograph = __webpack_require__(50);
	
	var _senograph2 = _interopRequireDefault(_senograph);
	
	var _senograph2x = __webpack_require__(51);
	
	var _senograph2x2 = _interopRequireDefault(_senograph2x);
	
	var _roentgen = __webpack_require__(159);
	
	var _roentgen2 = _interopRequireDefault(_roentgen);
	
	var _roentgen2x = __webpack_require__(160);
	
	var _roentgen2x2 = _interopRequireDefault(_roentgen2x);
	
	var _lunar = __webpack_require__(157);
	
	var _lunar2 = _interopRequireDefault(_lunar);
	
	var _lunar2x = __webpack_require__(158);
	
	var _lunar2x2 = _interopRequireDefault(_lunar2x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServicesPage = function ServicesPage(props) {
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(_page2.default, { headline: 'Unsere Untersuchungen' }),
	    _react2.default.createElement(
	      'section',
	      { className: 'container-custom split' },
	      _react2.default.createElement(
	        _contentblock2.default,
	        { title: 'F\xFCr alle unsere Untersuchungen bitten wir Sie, Folgendes zu beachten:' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'feature-list' },
	          _react2.default.createElement(
	            'li',
	            null,
	            'Bringen Sie zu Ihrem Termin ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'den Ausweis, den \xDCberweisungsschein'
	            ),
	            ' und die ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'E-card'
	            ),
	            ' mit.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Falls weder Deutsch noch Englisch gesprochen wird, ist die Begleitung durch einen ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Dolmetscher'
	            ),
	            ' erforderlich.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Skelettr\xF6ntgen, Lungen-/Thoraxr\xF6ntgen und Sch\xE4delr\xF6ntgen finden ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'ohne'
	            ),
	            ' Termin nach Voranmeldung statt.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'Unsere durchschnittliche Wartezeit f\xFCr eine MR-Untersuchung f\xFCr ASVG Versicherte entspricht den vertraglichen Vereinbarungen mit der Sozialversicherung.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'F\xFCr alle anderen Untersuchungen sind ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Terminvereinbarungen'
	            ),
	            ' per E-Mail, Telefon oder pers\xF6nlich in der Ordination n\xF6tig.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'aside',
	        { className: 'sidebar' },
	        _react2.default.createElement(_sidebar2.default, null)
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'container-custom' },
	      _react2.default.createElement(
	        'div',
	        { className: 'feature-grid' },
	        _react2.default.createElement(
	          _abblock2.default,
	          { card: true, img: _discovery2.default, img2x: _discovery2x2.default, link: '/leistungen/mrt' },
	          _react2.default.createElement(
	            _contentblock2.default,
	            { title: 'MRT', link: '/leistungen/mrt' },
	            'Die Abdomenbildgebung ist aufgrund der komplexen Anatomie eine anspruchs\xADvolle Untersuchung.'
	          )
	        ),
	        _react2.default.createElement(
	          _abblock2.default,
	          { card: true, img: _logiq2.default, img2x: _logiq2x2.default, link: '/leistungen/ultraschall' },
	          _react2.default.createElement(
	            _contentblock2.default,
	            { title: 'Ultraschall', link: '/leistungen/ultraschall' },
	            'Unter Ultraschall versteht man Schallwellen oberhalb der menschlichen H\xF6rgrenze.'
	          )
	        ),
	        _react2.default.createElement(
	          _abblock2.default,
	          { card: true, img: _senograph2.default, img2x: _senograph2x2.default, link: '/leistungen/mammographie' },
	          _react2.default.createElement(
	            _contentblock2.default,
	            { title: 'Mammographie', link: '/leistungen/mammographie' },
	            'Die Mammographie ist eine spezielle R\xF6ntgenuntersuchung der Brust.'
	          )
	        ),
	        _react2.default.createElement(
	          _abblock2.default,
	          { card: true, img: _roentgen2.default, img2x: _roentgen2x2.default, link: '/leistungen/roentgen' },
	          _react2.default.createElement(
	            _contentblock2.default,
	            { title: 'Digitales R\xF6ntgen', link: '/leistungen/roentgen' },
	            'Unter digitalem R\xF6ntgen versteht man ein bildgebendes Verfahren.'
	          )
	        ),
	        _react2.default.createElement(
	          _abblock2.default,
	          { card: true, img: _lunar2.default, img2x: _lunar2x2.default, link: '/leistungen/dexa' },
	          _react2.default.createElement(
	            _contentblock2.default,
	            { title: 'DEXA', link: '/leistungen/dexa' },
	            'Als Knochendichtemessung, auch Dexamessung, werden medizinisch-technische Verfahren bezeichnet, die zur Bestimmung der Dichte bzw. des Kalksalzgehaltes des Knochens dienen.'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = ServicesPage;
	module.exports = exports['default'];

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/discovery.a22c1b16.jpg";

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/discovery@2x.0ea30641.jpg";

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logiq.35c65923.jpg";

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logiq@2x.1609ba8e.jpg";

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/lunar.a25e823d.jpg";

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/lunar@2x.dde8a31c.jpg";

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roentgen.2eab88c8.jpg";

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/roentgen@2x.d9089e24.jpg";

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/senograph.7a269417.jpg";

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/senograph@2x.381363bd.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-leistungen-js-f51861ebbe2fc787507d.js